export enum ServiceTypeEnum {
  Free = "Free",
  OneOfCharge = "One-Off Charge",  
  DailyCharge = "Daily Charge", //deprecated, used only for old services
  OneOffChargeAndDaily = "One-Off Charge/Daily Charge" //deprecated, used only for old services
}